export const normalizeJssFields = (data: object, filters = []): any => {
  if (!data) {
    return data;
  }

  let normalized = {};

  const keys = Object.keys(data).filter((key) => !filters.length || filters.indexOf(key) > -1);

  keys.forEach((key) => {
    const val = data[key];
    if (val && typeof val === 'object' && val.hasOwnProperty('jss')) {
      normalized[key] = val.jss;
    } else {
      normalized[key] = val;
    }
  });

  return normalized;
};
